/* 
  INFO: This function can be create a random id for your selected length. 
  PARAMETERS: length(type: integer, info: character length)
  IMPORT: import idCreator from 'src/helpers/id-creator';
  USAGE: idCreator(32);
*/
const idCreator = (length) => {
  if (!length || length === true) return 0;
  let result = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

module.exports = idCreator;
